export const clientAuthConstants = {
  VERIFY_OTP_LOADING: "VERIFY_OTP_LOADING",
  VERIFY_OTP_ERROR: "VERIFY_OTP_ERROR",
  VERIFY_OTP_SUCCESS: "VERIFY_OTP_SUCCESS",
};
